// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
  checkStoreData,
  getStoreData,
  initStoreData,
  updateStoreData,
} from 'src/storage';
import {
  priorityExecuteLastSessionData,
  priorityProcessQueue,
  priorityExecuteLocalStorage,
} from './priorityQueue';
import {
  batchedProcessQueue,
  batchedExecuteLocalStorage,
  batchedExecuteLastSessionData,
} from './batchQueue';
import {
  GODAVARI_EVENT_TYPE,
  SESSION_KEY_STORAGE_TYPE,
  SESSION_STORAGE_TYPE,
} from 'src/utils/enum';
import { getAppSessionId, getCurrentTime } from 'src/utils';
import { getSDKConfig } from 'src/utils/config';
let batchInterval;
let maxRecordLimitInterval;
let batchStoreData = [];
let batch_id = 0;

const initQueueManager = () => {
  initStorageQueue();
  window.addEventListener('online', checkNetworkOnline);
  window.addEventListener('offline', checkNetworkOffline);
  checkMaxBeaconCounter();
  batch_id = Date.now();
  startBatchedInterval();
  registerBodyUnload();
};

const initStorageQueue = () => {
  const storageType = SESSION_STORAGE_TYPE;
  const storageTypeList = SESSION_KEY_STORAGE_TYPE;
  for (const key in storageTypeList) {
    if (storageTypeList[key]) {
      const sessionId = storageType[key] + getAppSessionId();
      initStoreData(storageTypeList[key], sessionId);
    }
  }
};

const checkNetworkOnline = () => {
  if (window.spnGlobalConfig.spnBeaconNetworkStatus == false) {
    window.spnGlobalConfig.spnBeaconNetworkStatus = true;
    window.spnGlobalConfig.priorityBeaconExecutionStart = false;
    window.spnGlobalConfig.batchedBeaconExecutionStart = false;
    executeCurrentSessionData();
    executeLastSessionStoreData();
  }
};

const checkNetworkOffline = () => {
  if (window.spnGlobalConfig.spnBeaconNetworkStatus) {
    window.spnGlobalConfig.spnBeaconNetworkStatus = false;
    window.spnGlobalConfig.priorityBeaconExecutionStart = true;
    window.spnGlobalConfig.batchedBeaconExecutionStart = true;
  }
};

const storeNextData = (eventType, eventName, payLoadBody) => {
  if (eventType == 'priority') {
    storeRecordData(eventType, eventName, payLoadBody);
  }
  storeBatchData(GODAVARI_EVENT_TYPE.BATCHED, eventName, payLoadBody);
};

const storeRecordData = (eventType, eventName, payLoadBody) => {
  const storageType = SESSION_STORAGE_TYPE;
  const storageTypeList = SESSION_KEY_STORAGE_TYPE;
  const sessionId = storageType[eventType] + getAppSessionId();
  checkStoreData(storageTypeList[eventType], sessionId);
  let localStorageData = getStoreData(sessionId);
  const payLoadData = {
    eventType: eventType,
    eventName: eventName,
    currentTime: getCurrentTime(),
    payLoadBody: payLoadBody,
  };
  if (!Array.isArray(localStorageData)) {
    localStorageData = [];
  }
  const offlineCache = checkOfflineCache(eventType, localStorageData);
  if (offlineCache) {
    return;
  }
  localStorageData.push(payLoadData);
  updateStoreData(sessionId, localStorageData);
  startProcess(eventType);
};

const checkOfflineCache = (eventType, localStorageData) => {
  const sdkConfig = getSDKConfig();
  if (!window?.navigator?.onLine) {
    switch (eventType) {
      case 'priority':
        if (
          sdkConfig?.priority?.offline_cache_enabled &&
          localStorageData.length >= sdkConfig?.priority?.offline_cache_max_size
        ) {
          return true;
        } else if (!sdkConfig?.priority?.offline_cache_enabled) {
          return true;
        }
        break;
      case 'batched':
        if (
          sdkConfig?.batch?.offline_cache_enabled &&
          localStorageData.length >= sdkConfig?.batch?.offline_cache_max_size
        ) {
          return true;
        } else if (!sdkConfig?.batch?.offline_cache_enabled) {
          return true;
        }
        break;
    }
  }
  return false;
};

const storeBatchData = (eventType, eventName, payLoadBody = {}) => {
  const sdkConfig = getSDKConfig();
  const storageType = SESSION_STORAGE_TYPE;
  const storageTypeList = SESSION_KEY_STORAGE_TYPE;
  const sessionId = storageType[eventType] + getAppSessionId();
  checkStoreData(storageTypeList[eventType], sessionId);
  let localStorageData = getStoreData(sessionId);
  if (!Array.isArray(localStorageData)) {
    localStorageData = [];
  }
  const offlineCache = checkOfflineCache(eventType, localStorageData);
  if (offlineCache) {
    return;
  }
  let maxEventPer = sdkConfig?.batch?.queue_size;
  if (sdkConfig?.batch?.queue_size > sdkConfig?.batch?.max_events_per_beacon) {
    maxEventPer = sdkConfig?.batch?.max_events_per_beacon;
  }
  if (batchStoreData.length >= maxEventPer) {
    storeRecordData(
      GODAVARI_EVENT_TYPE.BATCHED,
      'batched_name',
      batchStoreData
    );
    batch_id = Date.now();
    batchStoreData = [];
  }
  if (payLoadBody && eventType === GODAVARI_EVENT_TYPE.BATCHED) {
    payLoadBody.batch_id = batch_id.toString();
  }
  batchStoreData.push(payLoadBody);
  window.batchStoreData = batchStoreData;
};

const startBatchedInterval = () => {
  const sdkConfig = getSDKConfig();
  let batchIntervalTime = sdkConfig?.batch?.batch_interval || 300000; // Interval for batching events in seconds (5 minutes)
  clearTimeout(batchInterval);
  batchInterval = setTimeout(() => {
    if (batchStoreData.length > 0) {
      storeRecordData(
        GODAVARI_EVENT_TYPE.BATCHED,
        'batched_name',
        batchStoreData
      );
      batch_id = Date.now();
      batchStoreData = [];
    }
    startBatchedInterval();
  }, batchIntervalTime);
};

const startProcess = (eventType) => {
  if (window.spnGlobalConfig.spnBeaconNetworkStatus) {
    switch (eventType) {
      case GODAVARI_EVENT_TYPE.PRIORITY:
        if (window.spnGlobalConfig.priorityBeaconExecutionStart) {
          window.spnGlobalConfig.priorityBeaconExecutionStart = false;
          priorityProcessQueue();
        }
        break;
      case GODAVARI_EVENT_TYPE.BATCHED:
        if (window.spnGlobalConfig.batchedBeaconExecutionStart) {
          window.spnGlobalConfig.batchedBeaconExecutionStart = false;
          batchedProcessQueue();
        }
        break;
    }
  }
};

// when current uuid remove from storage it will be execute first.
const executeCurrentBatchData = () => {
  const sdkConfig = getSDKConfig();
  if (batchStoreData.length == sdkConfig?.batch?.max_events_per_beacon) {
    storeRecordData(
      GODAVARI_EVENT_TYPE.BATCHED,
      'batched_name',
      batchStoreData
    );
    batchStoreData = [];
  }
};

const executeCurrentSessionData = () => {
  priorityExecuteLocalStorage();
  batchedExecuteLocalStorage();
};

const executeLastSessionStoreData = () => {
  priorityExecuteLastSessionData();
  batchedExecuteLastSessionData();
};

const checkMaxBeaconCounter = () => {
  clearInterval(maxRecordLimitInterval);
  maxRecordLimitInterval = setTimeout(() => {
    window.spnGlobalConfig.maxRecordPerMinute = 0;
    checkMaxBeaconCounter();
  }, 60000);
};

const registerBodyUnload = () => {
  window.addEventListener('beforeunload', onUnloadExecuteBatchData);
};

const onUnloadExecuteBatchData = () => {
  if (batchStoreData.length > 0) {
    window.spnGlobalConfig.batchedBeaconExecutionStart = false;
    storeRecordData(
      GODAVARI_EVENT_TYPE.BATCHED,
      'batched_name',
      batchStoreData
    );
    batchStoreData = [];
  }
};

export {
  initStorageQueue,
  initQueueManager,
  storeNextData,
  executeLastSessionStoreData,
  checkNetworkOnline,
  checkNetworkOffline,
  executeCurrentBatchData,
  checkMaxBeaconCounter,
};
